export default __webpack_public_path__ + "static/media/egg.00be0002.svg";